import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import styles from './ARecommend.module.less';

import ABanner from './ABanner';
import ATab from './ATab';
import AGroup from './AGroup';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function ARecommend() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    // 推荐页面PV打桩  必须设备信息获取成功之后进行
    dispatch(
      logging({
        category: 'P',
        action: 'A_Recommend',
        label: '',
        param2: {
          source: 'A_Recommend',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'A_Recommend',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  return (
    <>
      <div className={styles.android}>
        <ABanner />
        <ATab />
        <AGroup />
      </div>
    </>
  );
}
//});

export default () => (
  <KeepAlive name="ARecommend">
    <ARecommend></ARecommend>
  </KeepAlive>
);
